function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#D3CBD6"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 11)",
  stroke: "#363139",
  strokeWidth: 0.9
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.45,
  y: 4.45,
  width: 17.1,
  height: 13.1,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 4a4 4 0 10-8 0"
})));

function SvgCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MTM3REEyQzctRDEwOC00ODJFLUFFOEUtNTg3RUU2NEExMjI0PC90aXRsZT4KICAgIDxnIGlkPSIxMy4tTXktQWNjb3VudCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRfMTNfTXktQWNjb3VudF8wMC0tLVNpZ24tSW4tLy1SZWdpc3Rlcl9hY3RpdmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MzguMDAwMDAwLCAtNTU1LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iQ2hlY2tvdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczOC4wMDAwMDAsIDU1NS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yNiIgZmlsbD0iI0QzQ0JENiI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxnIGlkPSJJY29uL0Jhc2tldCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAxMS4wMDAwMDApIiBzdHJva2U9IiMzNjMxMzkiIHN0cm9rZS13aWR0aD0iMC45Ij4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAiPgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwLjQ1IiB5PSI0LjQ1IiB3aWR0aD0iMTcuMSIgaGVpZ2h0PSIxMy4xIiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTMsNCBDMTMsMS43OTA4NjEgMTEuMjA5MTM5LDAgOSwwIEM2Ljc5MDg2MSwwIDUsMS43OTA4NjEgNSw0IiBpZD0iT3ZhbCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgCheckout as ReactComponent };